import { MobileOfferStoreState, MobileOfferStoreStatus } from '@numeo/types'

export function StoreStatusBadge({ store }: { store: MobileOfferStoreState }) {
    const ready = store.status === MobileOfferStoreStatus.READY
    const failed = store.status === MobileOfferStoreStatus.FAILED
    const color = ready
        ? 'bg-green-50 text-green-700 dark:bg-green-900/30 dark:text-green-300'
        : failed
          ? 'bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-300'
          : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400'
    return (
        <span className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${color}`}>
            {ready ? 'Configured' : failed ? 'Needs attention' : 'Not configured'}
        </span>
    )
}
